import {
  GET_TICKETS,
  GET_TICKET_PROFILE,
  CLEAR_TICKETS,
} from 'redux/actions/types';

const initialState = { isLoading: true };

const tickets = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_TICKETS:
      return {
        ...state,
        tickets: data.tickets,
        companySections: data.companySections,
        isLoading: false,
      };
    case GET_TICKET_PROFILE:
      return {
        ...state,
        ticketProfile: data,
      };
    case CLEAR_TICKETS:
      return {
        isLoading: true,
      };
    default:
      return state;
  }
};

export default tickets;
